import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Quote } from 'lucide-react';
import type { Testimonial } from '../data/testimonials';
interface FeaturedTestimonialProps {
  testimonial: Testimonial;
}
export function FeaturedTestimonial({
  testimonial
}: FeaturedTestimonialProps) {
  return <figure className="border border-rose/60 bg-rose-50 p-7 sm:p-10" data-id="element-290" data-mp="3vp169ud26pa">
      <Quote size={30} strokeWidth={1} className="text-rose-700" aria-hidden="true" data-id="element-291" data-mp="33au05k03azop" />
      <blockquote className="mt-5 font-serif text-xl italic leading-relaxed text-charcoal sm:text-2xl" data-id="element-292" data-mp="37bdygqweg9cf">
        “{testimonial.excerpt}”
      </blockquote>
      <figcaption className="mt-6 flex flex-col gap-5 border-t border-rose/30 pt-4 sm:flex-row sm:items-end sm:justify-between" data-id="element-293" data-mp="3cdlepso9ibkk">
        <div data-id="element-294" data-mp="rlj8ycztp52o">
          <p className="font-serif text-lg text-charcoal" data-id="element-295" data-mp="rlt4eg3n04fr">
            {testimonial.name}
          </p>
          {testimonial.location && <p className="mt-1 text-sm text-charcoal-50" data-id="element-296" data-mp="wm7c1x1btcd9">
              {testimonial.location}
            </p>}
        </div>
        <Link to={`/testimonials#${testimonial.id}`} className="group inline-flex w-fit items-center gap-2 border border-rose-700 px-4 py-2 text-xs font-medium tracking-[0.14em] text-rose-700 uppercase transition-colors hover:bg-rose-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-rose-700 focus:ring-offset-2 focus:ring-offset-rose-50" aria-label={`Read ${testimonial.name}'s full testimonial`} data-id="element-297" data-mp="1sdvz4a2qo6zf">
          Read more
          <ArrowRight size={15} strokeWidth={1.5} className="transition-transform group-hover:translate-x-0.5" aria-hidden="true" data-id="element-298" data-mp="18nsiwcumnsrm" />
        </Link>
      </figcaption>
    </figure>;
}